{
  "about": {
    "title": "關於 Spring Boot Admin",
    "label": "關於"
  }
}
